function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 1,
  width: 25,
  height: 23
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,1 C16.1045695,1 17,1.8954305 17,3 L18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,20 C21,21.6568542 19.6568542,23 18,23 L18,23 L6,23 C4.34314575,23 3,21.6568542 3,20 L3,20 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 L7,3 C7,1.8954305 7.8954305,1 9,1 L15,1 Z M7,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,20 C5,20.5522847 5.44771525,21 6,21 L6,21 L18,21 C18.5522847,21 19,20.5522847 19,20 L19,20 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 L17,5 C17,6.1045695 16.1045695,7 15,7 L9,7 C7.8954305,7 7,6.1045695 7,5 Z M15,3 L9,3 L9,5 L15,5 L15,3 Z",
  id: "icon",
  fill: "#333333"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "mask-icon",
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#000"
}));

var SvgSurveys = function SvgSurveys(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSurveys, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/surveys.fbc1cb1d.svg";
export { ForwardRef as ReactComponent };